import React, { useState, useEffect } from 'react';
import { Modal, Button, TextField, Grid } from '@mui/material';

function UtilidadModal({ open, handleClose, usuarioActual, utilidadToEdit = null, onSave }) {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [descripcionUtilidad, setDescripcionUtilidad] = useState('');
  const [ingresadoPor, setIngresadoPor] = useState(usuarioActual || ''); 
  const [fechaIngreso, setFechaIngreso] = useState(new Date().toISOString().split('T')[0]); 
  const [modificacion, setModificacion] = useState(1); 
  const [isEditing, setIsEditing] = useState(false);

  // Cargar datos de la utilidad cuando se abre el modal en modo edición
  useEffect(() => {
    if (utilidadToEdit) {
      console.log('UtilidadModal recibió utilidadToEdit:', utilidadToEdit);
      setDescripcionUtilidad(utilidadToEdit.descripcionUtilidad || '');
      setIsEditing(true);
    } else {
      setDescripcionUtilidad('');
      setIsEditing(false);
    }
  }, [utilidadToEdit, open]);

  const handleGuardarUtilidad = async () => {
    try {
      let response;
      
      if (isEditing) {
        // Validar que tenemos el ID necesario para la actualización
        if (!utilidadToEdit || !utilidadToEdit.idUtilidad) {
          alert('Error: No se puede actualizar - falta el ID de la utilidad');
          return;
        }
        
        // Para actualizar, necesitamos enviar el objeto completo con todas las propiedades
        const utilidadData = {
          IdUtilidad: utilidadToEdit.idUtilidad, // Importante: el controlador valida que el ID coincida
          DescripcionUtilidad: descripcionUtilidad,
          IngresadoPor: utilidadToEdit.ingresadoPor || ingresadoPor || 'ADMIN',
          FechaIngreso: utilidadToEdit.fechaIngreso || new Date().toISOString(),
          ModificadoPor: ingresadoPor || 'ADMIN',
          Modificacion: 2 // Indica que es una actualización
        };
        
        console.log('Datos a enviar para actualizar:', utilidadData);
        
        response = await fetch(`${server}/CdmUtilidades/${utilidadToEdit.idUtilidad}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(utilidadData),
        });
      } else {
        // Crear nueva utilidad
        const utilidadData = {
          DescripcionUtilidad: descripcionUtilidad,
          IngresadoPor: ingresadoPor || 'ADMIN',
          FechaIngreso: new Date().toISOString(),
          Modificacion: 1
        };
        
        console.log('Datos a enviar para crear:', utilidadData);
        
        response = await fetch(`${server}/CdmUtilidades`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(utilidadData),
        });
      }

      if (response.ok) {
        alert(`Utilidad ${isEditing ? 'actualizada' : 'guardada'} correctamente`);
        
        // Llamar al callback para actualizar la lista
        if (onSave) {
          onSave();
        }
      } else {
        // Obtener más detalles del error
        const errorText = await response.text();
        console.error(`Error response (${response.status}):`, errorText);
        alert(`Error al ${isEditing ? 'actualizar' : 'guardar'} la utilidad: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      alert('Error al conectarse con el servidor');
      console.error('Error en la solicitud:', error);
    }

    // Limpiar y cerrar el modal
    setDescripcionUtilidad('');
    setIsEditing(false);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={{ padding: '20px', background: 'white', margin: '50px auto', maxWidth: '500px' }}>
        <h2>{isEditing ? 'Editar Utilidad' : 'Agregar Utilidad'}</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descripción de la Utilidad"
              value={descripcionUtilidad}
              onChange={(e) => setDescripcionUtilidad(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button 
              onClick={handleGuardarUtilidad} 
              variant="contained" 
              color="primary"
              disabled={!descripcionUtilidad.trim()}
            >
              {isEditing ? 'Actualizar' : 'Guardar'}
            </Button>
            <Button 
              onClick={handleClose} 
              variant="outlined" 
              color="secondary" 
              style={{ marginLeft: '10px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default UtilidadModal;
